import React, { FC } from 'react';

import { isAgent } from '~/utils/getDecodedJwt';
import ContactUs from './ContactUs';
import GoToDashboardButton from './GoToDashboardButton';

interface Props {
  contactUsUrl: string;
  contactUsTextPosition?: 'left' | 'right';
}

const BottomLeftActions: FC<Props> = (props) => {
  const { contactUsUrl, contactUsTextPosition } = props;
  return isAgent() ? <GoToDashboardButton /> : <ContactUs textPosition={contactUsTextPosition} url={contactUsUrl} />;
};

export default BottomLeftActions;
